import { Component, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-schema',
  templateUrl: './schema.component.html',
  styleUrls: ['./schema.component.scss']
})
export class SchemaComponent {
@Input('schema') schema : string;

constructor(private renderer: Renderer2) {}

  ngOnInit() {
    // if (!this.schema) return;
    if (this.schema) {
      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.text = this.schema;
      this.renderer.appendChild(document.head, script);
    }
    else {
      console.log('schema is null');
    }
  }

}
